// extracted by mini-css-extract-plugin
module.exports = {"table":"AssignRecurrenceAvailableOperatorsModal_table__1iYWr"};